import type { Score } from "./types";

/**
 * Risk = Exposure x Vulnerability, via lookup matrix (NOT multiplication).
 * Functional spec §2.1. Row = exposure, column = vulnerability.
 */
const RISK_MATRIX: Readonly<Record<Score, Readonly<Record<Score, Score>>>> = {
  1: { 1: 1, 2: 1, 3: 2, 4: 2 },
  2: { 1: 1, 2: 2, 3: 3, 4: 3 },
  3: { 1: 2, 2: 3, 3: 3, 4: 4 },
  4: { 1: 2, 2: 3, 3: 4, 4: 4 },
};

export function scoreRisk(exposure: Score, vulnerability: Score): Score {
  return RISK_MATRIX[exposure][vulnerability];
}
